import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem, Autocomplete, FormControl, FormHelperText } from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useUserStore } from "../../../hooks/UseUserStore";
import { useCompanyStore } from "../../../hooks/useCompanyStore";
import { readLocalStorage } from "../../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../../types";
import { Role } from "../../../types/roles/roleTypes";
import { unmaskRUT } from "../../../toolbox/helpers/rut-helper";
import { useSupplierStore } from "../../../hooks/useSupplierStore";
import { Supplier } from "../../../types/slices/supplierType";

type Values = {
    id: number,
    rut: string,
    username: string,
    idprivilege: number,
    email: string,
    phone: string,
    idcompanies: any,
    iduser_type: number,
    password: string,
    password_confirmation: string,
    edit_price: 0 | 1
    pin_price: string
}

const usersType = [
    { id: 2, name: "Administrador", status: "1" },
    { id: 6, name: "Comercial", status: "1" },
    { id: 3, name: "Vendedor", status: "1" },
    { id: 5, name: "Cliente", status: "1" },
]

export const UserModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, userSelected, listUser, clearState } = props;

    const { action, createUser, createUserBySuperadmin, editUser, getUserType, getPrivilege } = useUserStore();
    const { supppliers, getSuppliers } = useSupplierStore()
    const { getCompanies } = useCompanyStore();

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany || '';
    const role = userData?.userType || '';

    const [loading, setLoading] = useState(false);
    const [companies, setCompanies] = useState<any>([]);
    const [usertypes, setUsertypes] = useState<any>([]);
    const [privileges, setPrivileges] = useState<any>([]);
    const [data, setData] = useState<Values>({
        id: userSelected ? userSelected.id : '',
        rut: userSelected ? userSelected.rut : '',
        username: userSelected ? userSelected.username : '',
        idprivilege: userSelected ? userSelected.idprivilege : '',
        email: userSelected ? userSelected.email : '',
        phone: userSelected ? userSelected.phone : '',
        idcompanies: userSelected ? userSelected.idcompanies : '',
        iduser_type: userSelected ? userSelected.iduser_type : '',
        password: userSelected ? userSelected.password : 'demo',
        password_confirmation: userSelected ? userSelected.password_confirmation : 'demo',
        edit_price: userSelected?.edit_price || 0,
        pin_price: userSelected?.pin_price || ''
    });
    const [selectedSupplier, setSelectedSupplier] = useState<Supplier | null>(null)

    useEffect(() => {
        // getUserTypeApi();
        // getPrivilegeApi();
        getSuppliers()
    }, [])

    useEffect(() => {
        if (role == Role.SUPER_ADMIN) getcompaniesApi();
    }, [])

    useEffect(() => {
        if (userSelected && companies && role == Role.SUPER_ADMIN) {
            setData({ ...data, idcompanies: setCustomCompany(JSON.parse(userSelected.idcompanies), companies) })
        }
    }, [userSelected, companies])

    const getcompaniesApi = async () => {
        try {
            setLoading(true);
            const response = await getCompanies();
            if (!response) {
                setCompanies([]);
                setLoading(false);
                return false;
            } else {
                setCompanies(response);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getUserTypeApi = async () => {
        try {
            setLoading(true);
            const response = await getUserType();
            if (!response) {
                setUsertypes([]);
                setLoading(false);
                return false;
            } else {
                setUsertypes(response);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const getPrivilegeApi = async () => {
        try {
            setLoading(true);
            const response = await getPrivilege();
            if (!response) {
                setPrivileges([]);
                setLoading(false);
                return false;
            } else {
                setPrivileges(response);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const validateForm = (values) => {
        let errors: any = {};

        if (!values.rut) errors.rut = "el campo es requerido";
        if (!values.iduser_type) errors.iduser_type = "el campo es requerido";
        // if (!values.idprivilege) errors.idprivilege = "el campo es requerido";
        if (!values.email) errors.email = "el campo es requerido";
        if (!values.password && !userSelected) errors.password = "el campo es requerido";
        if (!values.idcompanies && role == Role.SUPER_ADMIN) errors.idcompanies = "el campo es requerido";
        // if (values.edit_price === null) errors.edit_price = "el campo es requerido";

        return errors;
    }

    const handleKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 189 || keyCode === 109) {
            event.preventDefault();
        }
    };

    const setCustomCompany = (idcompanies, companies) => {
        const data = idcompanies ? idcompanies.map(idcompany => companies.find(company => company.id == idcompany)) : [];
        return getCustomCompanies(data);
    }
    const getCustomCompanies = (originalRoles) => {
        return originalRoles ? originalRoles.map(company => ({ ...company })) : [];
    }
    const customCompanies = getCustomCompanies(companies || []);

    const onSubmit = async (values) => {

        setLoading(true);

        let formdata = {
            ...values,
            password_confirmation: values.password,
            rut: unmaskRUT(values.rut),
            idsupplier: selectedSupplier ? selectedSupplier.id : null,
        }

        if (role && role == Role.SUPER_ADMIN) {
            const idcompanies = (values.idcompanies).map(company => company.id) || [];
            formdata = { ...formdata, idcompanies: (role && role == Role.SUPER_ADMIN) ? JSON.stringify(idcompanies) : null, }
        }
        if (role && role == Role.ADMIN) {
            formdata = { ...formdata, idcompany: idcompany }
        }

        if (userSelected) {
            const response: any = await editUser(userSelected.id, formdata);
            if (response) {
                listUser && listUser();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            } else {
                setLoading(false);
                return false;
            }
        } else {
            const response: any = (role && role == Role.SUPER_ADMIN) ? await createUserBySuperadmin(formdata) : await createUser(formdata);
            if (response) {
                listUser && listUser();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            } else {
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{ style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' } }}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar usuario' : (action == 'add' ? 'Nuevo usuario' : 'Detalle de l usuario')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik
                    initialValues={data}
                    enableReinitialize
                    validate={validateForm}
                    onSubmit={onSubmit}
                >
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ padding: '20px' }}>
                                    <Grid item container xs={12} spacing={2}>
                                        {
                                            action != 'edit' && (
                                                <Grid item xs={12} md={6}>
                                                    <FormLabel>Username:</FormLabel>
                                                    <TextField
                                                        id="username"
                                                        type="text"
                                                        name="username"
                                                        fullWidth
                                                        size="small"
                                                        value={values.username}
                                                        onChange={handleChange}
                                                        error={errors.username && touched.username ? true : false}
                                                        helperText={errors.username && touched.username ? errors.username : ''}
                                                        inputProps={{ readOnly: action == 'detail' }}
                                                    />
                                                </Grid>
                                            )
                                        }

                                        <Grid item xs={12} md={6}>
                                            <FormLabel>RUT:</FormLabel>
                                            <TextField
                                                id="rut"
                                                type="text"
                                                name="rut"
                                                fullWidth
                                                size="small"
                                                value={values.rut}
                                                onChange={(e) => {
                                                    const { value } = e.target

                                                    let newValue = value

                                                    let cleanRut = value.replace(/[^0-9kK]/g, '').toUpperCase()

                                                    let rutBody = cleanRut.slice(0, -1)
                                                    let dv = cleanRut.slice(-1)

                                                    rutBody = rutBody.slice(0, 8)
                                                    dv = dv.replace(/[^0-9K]/g, '')

                                                    let formatted = ''
                                                    if (rutBody.length > 0) {
                                                        let reversed = rutBody.split('').reverse()
                                                        let withDots: string[] = []

                                                        for (let i = 0; i < reversed.length; i++) {
                                                            withDots.push(reversed[i])
                                                            if ((i + 1) % 3 === 0 && i + 1 < reversed.length) {
                                                                withDots.push('.')
                                                            }
                                                        }

                                                        formatted = withDots.reverse().join('')
                                                    }

                                                    if (dv) {
                                                        formatted += `-${dv}`
                                                    }

                                                    newValue = formatted

                                                    setFieldValue('rut', newValue)
                                                }}
                                                error={errors.rut && touched.rut ? true : false}
                                                helperText={errors.rut && touched.rut ? errors.rut : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>

                                        {
                                            action != 'edit' && (
                                                <>
                                                    <Grid item xs={12} md={6}>
                                                        <FormLabel>Tipo de usuario:</FormLabel>
                                                        <Select
                                                            id="iduser_type"
                                                            value={values.iduser_type}
                                                            size="small"
                                                            onChange={(event) => {
                                                                setFieldValue("iduser_type", event.target.value);
                                                            }}
                                                            error={errors.iduser_type && touched.iduser_type ? true : false}
                                                            inputProps={{ readOnly: action == 'detail' }}
                                                            fullWidth
                                                        >
                                                            {
                                                                usersType.map((usertype, i) => {
                                                                    return <MenuItem key={i} value={usertype.id}>{usertype.name}</MenuItem>;
                                                                })
                                                            }
                                                        </Select>
                                                    </Grid>
                                                    {values.iduser_type === 5 && (
                                                        <Grid item xs={12} md={6}>
                                                            <FormLabel>Cliente:</FormLabel>
                                                            <Autocomplete
                                                                value={selectedSupplier || null}
                                                                options={supppliers || []}
                                                                getOptionLabel={(opt) =>
                                                                    opt?.name_rz && opt?.rut ? `${opt.name_rz} - ${opt.rut}` : ''
                                                                }
                                                                isOptionEqualToValue={(opt, val) => opt.name_rz === val?.name_rz}
                                                                onChange={(e, newVal) => setSelectedSupplier(newVal)}
                                                                renderInput={(params) => (
                                                                    <TextField {...params} fullWidth size="small" />
                                                                )}
                                                            />
                                                        </Grid>
                                                    )}
                                                    {/* <Grid item xs={12} md={6}>
                                                        <FormLabel>Privilegio:</FormLabel>
                                                        <Select
                                                            id="idprivilege"
                                                            value={values.idprivilege}
                                                            size="small"
                                                            onChange={(event) => {
                                                                setFieldValue("idprivilege", event.target.value);
                                                            }}
                                                            error={errors.idprivilege && touched.idprivilege ? true : false}
                                                            inputProps={{ readOnly: action == 'detail' }}
                                                            fullWidth
                                                        >
                                                            {
                                                                privileges.map((privilege, i) => {
                                                                    return <MenuItem key={i} value={privilege.id}>{privilege.name}</MenuItem>;
                                                                })
                                                            }
                                                        </Select>
                                                    </Grid> */}
                                                </>
                                            )
                                        }

                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Email:</FormLabel>
                                            <TextField
                                                id="email"
                                                type="email"
                                                name="email"
                                                fullWidth
                                                size="small"
                                                value={values.email}
                                                onChange={handleChange}
                                                error={errors.email && touched.email ? true : false}
                                                helperText={errors.email && touched.email ? errors.email : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Teléfono:</FormLabel>
                                            <TextField
                                                id="phone"
                                                type="text"
                                                name="phone"
                                                fullWidth
                                                size="small"
                                                value={values.phone}
                                                onChange={handleChange}
                                                error={errors.phone && touched.phone ? true : false}
                                                helperText={errors.phone && touched.phone ? errors.phone : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>

                                        {(values.iduser_type === 2 || values.iduser_type === 6) && (
                                            <Grid item xs={12} md={6}>
                                                <FormLabel>Edición de precios:</FormLabel>
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                    error={Boolean(errors.edit_price && touched.edit_price)}
                                                >
                                                    <Select
                                                        id="edit_price"
                                                        name="edit_price"
                                                        value={values.edit_price}
                                                        onChange={handleChange}
                                                        inputProps={{ readOnly: action === 'detail' }}
                                                    >
                                                        <MenuItem value={1}>Sí</MenuItem>
                                                        <MenuItem value={0}>No</MenuItem>
                                                    </Select>
                                                    {errors.edit_price && touched.edit_price && (
                                                        <FormHelperText>{errors.edit_price}</FormHelperText>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        )}

                                        {values.edit_price === 1 && (
                                            <Grid item xs={12} md={6}>
                                                <FormLabel>PIN</FormLabel>
                                                <TextField
                                                    id="pin_price"
                                                    type="text"
                                                    name="pin_price"
                                                    fullWidth
                                                    size="small"
                                                    value={values.pin_price}
                                                    onChange={(e) => {
                                                        const regex = /^[0-9\b]+$/
                                                        const value = e.target.value

                                                        if ((value === '' || regex.test(value)) && value.length <= 4) {
                                                            setFieldValue('pin_price', value)
                                                        }
                                                    }}
                                                    error={errors.pin_price && touched.pin_price ? true : false}
                                                    helperText={errors.pin_price && touched.pin_price ? errors.pin_price : ''}
                                                    inputProps={{
                                                        readOnly: action === 'detail',
                                                        maxLength: 4
                                                    }}
                                                />
                                            </Grid>
                                        )}

                                        {
                                            ((role && role == Role.SUPER_ADMIN) && action != 'edit') && (
                                                <Grid item xs={12} md={6}>
                                                    <FormLabel>Compañias:</FormLabel>
                                                    <Autocomplete
                                                        multiple
                                                        id="combo-box-demo"
                                                        value={values.idcompanies || []}
                                                        options={customCompanies || []}
                                                        getOptionLabel={(option) => option.business_name || ""}
                                                        fullWidth
                                                        renderInput={(params) => <TextField {...params} />}
                                                        onChange={(e, newValue) => {
                                                            setFieldValue("idcompanies", newValue);
                                                        }}
                                                        size="small"
                                                        readOnly={action == 'detail'}
                                                    />
                                                </Grid>
                                            )
                                        }

                                        {
                                            !userSelected && (
                                                <Grid item xs={12} md={6}>
                                                    <FormLabel>Contraseña:</FormLabel>
                                                    <TextField
                                                        id="password"
                                                        type="text"
                                                        name="password"
                                                        fullWidth
                                                        size="small"
                                                        value={values.password}
                                                        onChange={handleChange}
                                                        error={errors.password && touched.password ? true : false}
                                                        helperText={errors.password && touched.password ? errors.password : ''}
                                                        inputProps={{ readOnly: true }}
                                                    />
                                                </Grid>
                                            )
                                        }

                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }

                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
    )
}